import React, { useState, useEffect } from 'react';
import { getTournamentMatches } from './services/Score';
import './css/TournamentTable.css';
import FlipperClock from './FlipperClock';

const TournamentTable = ({ tournamentDetails, gifObj, boardEndTime, setScoreFlag, setClockFlag }) => {

    const [currentPage, setCurrentPage] = useState(1);
    const [displayedRows, setDisplayedRows] = useState([]);
    const [data, setData] = useState([]);
    const [totalPages, setTotalPage] = useState(0);
    const rowsPerPage = 6;

    const makeTeamName = (teamName, gifObj) => {
        const nameSplit = teamName.trim().split(' ');
        if (nameSplit[0].length <= 5) {
            return nameSplit[0].trim();
        } else {
            return nameSplit[0].slice(0, 4).trim();
        }
    }

    useEffect(() => {
        const updateDisplayedRows = () => {
            const start = (currentPage - 1) * rowsPerPage;
            const end = start + rowsPerPage;
            setDisplayedRows(data.slice(start, end));
        };
        updateDisplayedRows();
        const interval = setInterval(() => {
            setCurrentPage((prevPage) => (prevPage % totalPages) + 1);
        }, 10000);
        return () => clearInterval(interval);
    }, [currentPage, data, totalPages]);

    useEffect(() => {
        const start = (currentPage - 1) * rowsPerPage;
        const end = start + rowsPerPage;
        setDisplayedRows(data.slice(start, end));
    }, [currentPage, data]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await getTournamentMatches(tournamentDetails.id);
                setData(result.data.teams);
                setTotalPage(Math.ceil(result.data.teams.length / rowsPerPage))
            } catch (error) {
                console.log('Error: Fetching tournaments=', error);
            }
        };
        const interval = setInterval(() => {
            fetchData();
        }, 30000);
        fetchData();
        return () => clearInterval(interval);
    }, [tournamentDetails, gifObj]);

    useEffect(() => {
    }, [displayedRows]);

    useEffect(() => {
        const handleResize = () => {
            const rows = document.querySelectorAll('tr');
            const rowHeight = 100 / (rowsPerPage + 1); // +1 for the header row

            rows.forEach(row => {
                row.style.height = `calc(${rowHeight}vh - 3.5px)`;
            });
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [rowsPerPage, displayedRows]);

    return (
        <div className="tournament">
            <div style={{ display: 'none' }}>
                <FlipperClock style={{ fontSize: '30px' }} boardEndTime={boardEndTime} setScoreFlag={setScoreFlag} setClockFlag={setClockFlag} />
            </div>
            <div className="points-container">
                <div className="left-skew">
                    <div className="left-unskew"></div>
                </div>
                <h1 style={{ color: '#000', paddingTop: '2px', fontSize: '4vw', fontFamily: ' Arial, sans-serif' }}>POINTS TABLE</h1>
                <div className="right-skew">
                    <div className="right-unskew"></div>
                </div>
            </div>
            <div className="table-container">
                <table className='points-table'>
                    <thead>
                        <tr>
                            <th className='table-head'>POS</th>
                            <th className='table-head'>TEAM</th>
                            <th className='table-head'>P</th>
                            <th className='table-head'>W</th>
                            <th className='table-head'>L</th>
                            <th className='table-head'>PTS</th>
                            <th className='table-head'>NRR</th>
                        </tr>
                    </thead>
                    <tbody>
                        {displayedRows.map((value, index) => (
                            <tr key={index}>
                                <td className='table-data'>{index + 1}</td>
                                <td className='table-data'>{makeTeamName(value.team_name)}</td>
                                <td className='table-data'>{value.played}</td>
                                <td className='table-data'>{value.won}</td>
                                <td className='table-data'>{value.lost}</td>
                                <td className='table-data'>{value.points}</td>
                                <td className='table-data'>{value.nrr}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TournamentTable;